<template>
  <article class="page-header">
    <header class="page-header__hgroup">
      <h1 class="page-header__title">Medioze</h1>
      <p>Web agency in Quebec City.</p>
    </header>

    <section class="layout-section__group">
      <div class="layout-section__hgroup">
        <h2 class="layout-section__heading">My contribution</h2>
        <p>This new digital agency needed a complete brand image. I worked with Vincent Lachance to meet the client’s needs. He was charged with the creation of the logotype as well as the brand identity itself while I was in charge of the design and development of the website.</p>
      </div>

      <ul class="layout-section__list">
        <li>Analysis of the competition</li>
        <li>Strategy to facilitate and encourage potential customers to contact the agency</li>
        <li>Design website mockups following the brand image guidelines</li>
        <li>Create transitions and animations with VueJS and Sass</li>
        <li>Implement the new website as an SPA using VueJS and Sass</li>
      </ul>
    </section>

    <section class="layout-section__group">
      <h2 class="layout-section__heading">Tools</h2>

      <ul class="layout-section__list">
        <li>Adobe XD, Photoshop, Illustrator</li>
        <li>HTML, SCSS, Vue JS</li>
      </ul>
    </section>
  </article>
</template>

<script>
export default {
  name: 'MediozeHeader'
}
</script>
